import React from 'react';
import { FiDownload } from 'react-icons/fi';

import moment from 'moment';

import colors from '~/styles/colors';

import { Container, TextContent, Title, Body, DownloadContent } from './styles';

interface CreationRange {
  start: Date;
  finish: Date;
}

type HistoryItemProps = {
  generatedAt: Date;
  creationRange?: CreationRange;
  reportId: number;
  reportToken: string;
  status: string;
};

const DATE_FORMAT = 'DD/MM/YYYY';
const TIME_FORMAT = 'HH:mm';

const HistoryItem: React.FC<HistoryItemProps> = ({
  generatedAt,
  creationRange,
  reportId,
  reportToken,
  status,
}) => {
  const DOMAIN = localStorage.getItem('@Afferolab:domain');

  return (
    <Container status={status}>
      <TextContent>
        <Title>
          Gerado em {moment(generatedAt).format(DATE_FORMAT)} às{' '}
          {moment(generatedAt).format(TIME_FORMAT)}
        </Title>
        {creationRange && (
          <Body>
            Período do relatório{' '}
            {creationRange &&
              `${moment(creationRange.start).format(DATE_FORMAT)} -
                ${moment(creationRange.finish).format(DATE_FORMAT)}
              `}
          </Body>
        )}
      </TextContent>
      <DownloadContent>
        {status === 'Finalizado' ? (
          <a
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
            href={`${DOMAIN}/rest/tracking/reports/${reportId}/download-async?token=${reportToken}`}
          >
            <FiDownload size={18} color={colors.primary} />
          </a>
        ) : (
          <a
            style={{
              display: 'flex',
              alignItems: 'center',
              pointerEvents: 'none',
            }}
            href={`${DOMAIN}/rest/tracking/reports/${reportId}/download-async?token=${reportToken}`}
          >
            <FiDownload size={18} color={colors.gray} />
          </a>
        )}
      </DownloadContent>
    </Container>
  );
};

export default HistoryItem;
